<template>
    <span>
        <select v-model="ComputedValue">
            <option value="Set By Roles" title="The user's access determined by roles assigned.">Set By Roles</option>
            <option value="Allowed" title="Access always granted">Allowed</option>
            <option title="Access denied" value="Blocked">Blocked</option>
        </select>
    </span>
</template>

<script>
    export default {
        name: 'NullableUserDataTableSelect',
        props: ["value"],
        computed: {
            ComputedValue: {
                get: function(){
                    return (this.value === false) ? "Blocked" : (this.value === true ? "Allowed" : "Set By Roles");
                },
                set: function (newValue) {
                    switch (newValue) {
                        case "Blocked":
                            this.$emit('input', false);
                            break;
                        case "Allowed":
                            this.$emit('input', true);
                            break;
                        case "Set By Roles":
                            this.$emit('input', null);
                            break;
                    }
                }
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->